const routes = [
  {
    path: ["/", "/home"],
    exact: true,
    component: "Home",
  },
  {
    path: ["/gallery"],
    exact: true,
    component: "Gallery",
  },
];

export default routes;
